import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45a1d98c")

_pushScopeId("data-v-45a1d98c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 患者一括登録 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "①一括登録用テンプレートダウンロード", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("以下の患者登録用のcsvテンプレートファイルをダウンロードしてください。")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("csvをexcelなどで編集して、csv形式で保存してください。")
const _hoisted_5 = { class: "vue-content-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("a", {
  href: "/患者登録csvテンプレート.csv",
  download: ""
}, "患者登録csvテンプレート.csv", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", null, "②一括登録アップロード", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("編集したcsvファイルをアップロードして下さい。")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("ファイルに問題がなければ、患者の一括登録を行います。")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ここにcsvファイルをドラッグ&ドロップするか、")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("ファイル選択ボタンを押してcsvファイルを選択してください。")
const _hoisted_13 = {
  key: 0,
  class: "error-list"
}
const _hoisted_14 = { class: "error-title" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("エラー一覧")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_description = _resolveComponent("description")
  const _component_file_name_text = _resolveComponent("file-name-text")
  const _component_vue_content_item_frame = _resolveComponent("vue-content-item-frame")
  const _component_vue_sub_content = _resolveComponent("vue-sub-content")
  const _component_drop_area = _resolveComponent("drop-area")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_content, { class: "vue-content-remain-child" }, {
            default: _withId(() => [
              _createVNode(_component_vue_sub_content, null, {
                default: _withId(() => [
                  _hoisted_2,
                  _createVNode(_component_vue_content_item_frame, null, {
                    default: _withId(() => [
                      _createVNode(_component_description, null, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_description, null, {
                        default: _withId(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode("div", _hoisted_5, [
                        _createVNode(_component_file_name_text, null, {
                          default: _withId(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_vue_sub_content, { class: "vue-content-remain-child" }, {
                default: _withId(() => [
                  _hoisted_7,
                  _createVNode(_component_vue_content_item_frame, { class: "error-list" }, {
                    default: _withId(() => [
                      _createVNode(_component_description, null, {
                        default: _withId(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_description, null, {
                        default: _withId(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_drop_area, {
                        class: "drop-area",
                        "file-types": ['text/csv', 'application/octet-stream', 'application/vnd.ms-excel'],
                        onFile: _ctx.onDropCsv,
                        onError: _ctx.onDropError
                      }, {
                        default: _withId(() => [
                          _hoisted_10,
                          _hoisted_11,
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["file-types", "onFile", "onError"]),
                      (_ctx.errors.length>0)
                        ? (_openBlock(), _createBlock("div", _hoisted_13, [
                            _createVNode("h4", _hoisted_14, [
                              _createVNode(_component_fa_icon, { icon: "exclamation-circle" }),
                              _hoisted_15
                            ]),
                            _createVNode(_component_vue_y_scroll_area, null, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (err, i) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: `err-${i}`
                                  }, _toDisplayString(err), 1))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})